import { render } from "./FileProcessingPage.vue?vue&type=template&id=452cf59e&scoped=true"
import script from "./FileProcessingPage.vue?vue&type=script&lang=ts"
export * from "./FileProcessingPage.vue?vue&type=script&lang=ts"

import "./FileProcessingPage.vue?vue&type=style&index=0&id=452cf59e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-452cf59e"

export default script